export interface DataCapsule {
  setItem<T>(
    key: string,
    value: T,
    options?: Record<string, any>,
  ): Promise<void>;
  removeItem(key: string, options?: Record<string, any>): Promise<void>;
  getItem<T>(key: string): Promise<T>;
}
